import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import Loader from "../ui/Loader";
import { useAuth } from "../../context/AuthContext";

interface PrivateRouteProps {
  children: ReactElement;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { isAuthenticated, isLoading } = useAuth();

  // console.log('isAuthenticated ===>',isAuthenticated)
  if (isLoading) {
    return <Loader />;
  }

  return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
